import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './assets/css/App.css'
import Pocetna from './pages/Pocetna'
import Impressum from './pages/Impressum'
import Profil from './pages/Profil'
import PageNotFound from './pages/PageNotFound'
import { UserProvider } from './context/UserContext'
import { ModalProvider } from './context/ModalContext'
import { ArticlesProvider } from './context/ArticlesContext'
import GeneralModal from './components/modals/GeneralModal'
import Article from './pages/Article'
import { CategoryDropdownProvider } from './context/CategoryDropdownContext'
import ResetPassword from './pages/ResetPassword'
import ScrollToTop from './components/ScrollToTop'
import Footer from './components/Footer'
import Svijet from './pages/footer/korisni-linkovi/Svijet'
import Bih from './pages/footer/korisni-linkovi/Bih'
import JugoistocnaEvropa from './pages/footer/korisni-linkovi/JugoistocnaEvropa'
import Saradnja from './pages/footer/o-portalu/Saradnja'
import Kriteriji from './pages/footer/o-portalu/Kriteriji'
import PolitikaPrivatnosti from './pages/footer/PolitikaPrivatnosti'
import AuthorArticles from './pages/AuthorArticles'
import { PaginationProvider } from './context/PaginationContext'
import Authors from './pages/Authors'
import CookieBanner from './components/CookieBanner'
import LoggedInAuthChecker from './services/auth/LoggedInAuthChecker'
import ChangePassword from './pages/ChangePassword'
import ArticleRedirect from './routes/ArticleRedirect'
import Donacije from './pages/Donacije'
import GlobalSEO from './GlobalSEO'
import Kontakt from './pages/footer/Kontakt'
import ONama from './pages/footer/ONama'
import Navbar from './components/Navbar'
import TopBillboardLayout from './google-ads/TopBillboardLayout'
import { AD_UNITS } from './google-ads/adsConfig'
import { CookieConsentProvider } from './context/CookieConsentContext'

import { getLocalStorage } from './services/StorageHelper';
import Serials from './layouts/Serials'
import Serial from './pages/Serial'

const initGoogleAdsOnBoot = () => {
    if (window.googletag && window.googletag.apiReady) return;

    const script = document.createElement('script');
    script.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.onload = () => {
        window.googletag = window.googletag || { cmd: [] };
        window.googletag.cmd.push(function () {
            window.googletag.setConfig({ 
                singleRequest: true,
                collapseDiv: "BEFORE_FETCH",
            });
            window.googletag.pubads().setPrivacySettings({ nonPersonalizedAds: true });
            window.googletag.enableServices();
        });
    };
    document.head.appendChild(script);
};

initGoogleAdsOnBoot();

function App() {

  return (
    <div className="App">
      <ModalProvider>
        <UserProvider>
          <ArticlesProvider>
            <PaginationProvider>
              <CategoryDropdownProvider>
                <CookieConsentProvider>
                  <div className="hidden-overflow-x">
                    <BrowserRouter>
                    <GlobalSEO />
                      <ScrollToTop />
                      <Navbar />
                      <TopBillboardLayout 
                          unitPath={AD_UNITS.all.topBillboard.unitPath} 
                          divId={AD_UNITS.all.topBillboard.divId} 
                      />
                      <Routes>
                        <Route path='/' element={<Pocetna />} />
                        {/** Paths for filtering by categories and subcategories */}
                        <Route path='/historija-u-javnosti/*' element={<Pocetna />} />
                        <Route path='/recenzije/*' element={<Pocetna />} />
                        <Route path='/knjige/*' element={<Pocetna />} />
                        <Route path='/casopisi/*' element={<Pocetna />} />
                        <Route path='/clanci-i-polemike' element={<Pocetna />} />
                        <Route path='/promo' element={<Pocetna />} />
                        <Route path='/impressum' element={<Impressum />} />
                        <Route path='/profil' element={
                                                        <LoggedInAuthChecker>
                                                          <Profil />
                                                        </LoggedInAuthChecker>} />
                        <Route path='/autori' element={<Authors />} />
                        <Route path='/autori/:authorUrl' element={<AuthorArticles />} />
                        <Route path='/serijali' element={<Serials />} />
                        <Route path='/serijali/:url' element={<Serial />} />

                        {/** (Sub)categories paths for articles */}
                        <Route path='/historija-u-javnosti/dogadjaji/:url' element={<Article />} />
                        <Route path='/historija-u-javnosti/naucne-manifestacije/:url' element={<Article />} />
                        <Route path='/historija-u-javnosti/intervju/:url' element={<Article />} />
                        <Route path='/recenzije/svijet/:url' element={<Article />} />
                        <Route path='/recenzije/jugoistocna-evropa/:url' element={<Article />} />
                        <Route path='/recenzije/bosna-i-hercegovina/:url' element={<Article />} />
                        <Route path='/knjige/svijet/:url' element={<Article />} />
                        <Route path='/knjige/jugoistocna-evropa/:url' element={<Article />} />
                        <Route path='/knjige/bosna-i-hercegovina/:url' element={<Article />} />
                        <Route path='/casopisi/svijet/:url' element={<Article />} />
                        <Route path='/casopisi/jugoistocna-evropa/:url' element={<Article />} />
                        <Route path='/casopisi/bosna-i-hercegovina/:url' element={<Article />} />
                        <Route path='/clanci-i-polemike/:url' element={<Article />} />
                        <Route path='/promo/:url' element={<Article />} />

                        <Route path='/reset-password' element={<ResetPassword />} />
                        <Route path='/change-password' element={<ChangePassword />} />

                        {/** Footer pages */}
                        <Route path='/korisni-linkovi/svijet' element={<Svijet />} />
                        <Route path='/korisni-linkovi/jugoistocna-evropa' element={<JugoistocnaEvropa />} />
                        <Route path='/korisni-linkovi/bosna-i-hercegovina' element={<Bih />} />
                        {/* I Impressum odozgo*/}
                        <Route path='/kontakt' element={<Kontakt />} />
                        <Route path='/onama' element={<ONama />} />
                        <Route path='/saradnja' element={<Saradnja />} />
                        <Route path='/kriteriji-za-recenzije-i-radove' element={<Kriteriji />} />
                        <Route path='/politika-privatnosti' element={<PolitikaPrivatnosti />} />
                        <Route path='/donacije' element={<Donacije />} />

                        {/** Support for links from old architecture */}
                        <Route path='/article.php' element={<ArticleRedirect />} />

                        <Route path='*' element={<PageNotFound />} />
                      </Routes>
                      <Footer />
                    </BrowserRouter>
                    <GeneralModal />
                    <CookieBanner />
                  </div>
                </CookieConsentProvider>
              </CategoryDropdownProvider>
            </PaginationProvider>
          </ArticlesProvider>
        </UserProvider>
      </ModalProvider>
    </div>
  )
}

export default App;
